module.exports = __webpack_public_path__ + "assets/img/KS8303-M.4efb8a67.png";